import { render } from "./EntrevistaSocialAdm.vue?vue&type=template&id=7ecf4806&scoped=true"
import script from "./EntrevistaSocialAdm.vue?vue&type=script&lang=js"
export * from "./EntrevistaSocialAdm.vue?vue&type=script&lang=js"

import "./EntrevistaSocialAdm.vue?vue&type=style&index=0&id=7ecf4806&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecf4806"]])

export default __exports__